import React, { useState, useEffect } from "react";
import {
  Button,
  Popover,
  Dropdown,
  Slider,
  withField,
  Tooltip,
} from "@douyinfe/semi-ui";
import { ProteinAdvancedParamsModel } from "@services/home/model/home.model";
import { ReactComponent as AdvancedIcon } from "@assets/icons/advanced_icon.svg";

import styles from "./index.module.scss";
import classNames from "classnames";

interface Prop {
  value?: ProteinAdvancedParamsModel;
  onChange?: (values: any) => void;
  tryAdvanced: () => void;
}

const ProteinBinderAdvancedField: React.FC<Prop> = ({
  value,
  onChange,
  tryAdvanced,
}) => {
  const [visible, setVisible] = useState(false);
  const [targetCopies, setTargetCopies] = useState(1);
  const [binderLength, setBinderLength] = useState(150);
  const [binderCopies, setBinderCopies] = useState(1);

  function onTargetCopiesChange(v: number | number[] | undefined) {
    if (typeof v !== "number" || !onChange) {
      return;
    }
    setTargetCopies(v);

    onChange({
      target_copies: v,
      binder_length: binderLength,
      binder_copies: binderCopies,
    });
  }

  function onBinderLengthChange(v: number | number[] | undefined) {
    if (typeof v !== "number" || !onChange) {
      return;
    }

    setBinderLength(v);

    onChange({
      target_copies: targetCopies,
      binder_length: v,
      binder_copies: binderCopies,
    });
  }

  function onBinderCopiesChange(v: number | number[] | undefined) {
    if (typeof v !== "number" || !onChange) {
      return;
    }

    setBinderCopies(v);

    onChange({
      target_copies: targetCopies,
      binder_length: binderLength,
      binder_copies: v,
    });
  }

  function onClose() {
    setVisible(false);
  }
  function onOpen() {
    setVisible(!visible);
  }

  function toMainPage() {
    window.open("/promotion", "_blank");
  }

  function onAdvanced() {
    onClose();
    tryAdvanced();
  }

  useEffect(() => {
    if (!value) {
      if (onChange) {
        onChange({
          target_copies: targetCopies,
          binder_length: binderLength,
          binder_copies: binderCopies,
        });
      }
    } else {
      if (typeof value.target_copies !== "undefined") {
        setTargetCopies(value.target_copies);
      }

      if (typeof value.binder_length !== "undefined") {
        setBinderLength(value.binder_length);
      }

      if (typeof value.binder_copies !== "undefined") {
        setBinderCopies(value.binder_copies);
      }

      if (
        value.target_copies !== 1 ||
        value.binder_length !== 150 ||
        value.binder_copies !== 1
      ) {
        setVisible(true);
      }
    }
  }, [value]);

  return (
    <Popover
      trigger="custom"
      visible={visible}
      onClickOutSide={onClose}
      content={
        <div className={styles.advancedPopover}>
          <div className={styles.sliderContainer}>
            <div className={styles.label}>Target copies</div>
            <div className={styles.slider}>
              <Slider
                onChange={onTargetCopiesChange}
                showBoundary={true}
                size="small"
                min={1}
                max={4}
                step={1}
                value={targetCopies}
              ></Slider>
            </div>
          </div>
          <div className={styles.sliderContainer}>
            <div className={styles.label}>Binder length</div>
            <div className={styles.slider}>
              <Slider
                showBoundary={true}
                size="small"
                min={10}
                max={200}
                value={binderLength}
                onChange={onBinderLengthChange}
              ></Slider>
            </div>
          </div>
          <div className={styles.sliderContainer}>
            <div className={styles.label}>Binder copies</div>
            <div className={styles.slider}>
              <Slider
                showBoundary={true}
                size="small"
                step={1}
                min={1}
                max={4}
                value={binderCopies}
                onChange={onBinderCopiesChange}
              ></Slider>
            </div>
          </div>

          <div className={styles.noteWrapper}>
            <div className={styles.title}>Advanced Features</div>
            <div className={styles.desc}>
              Epitope and template structure conditioning is only available on{" "}
              <span className={styles.link} onClick={toMainPage}>
                GeoFlow Advanced
              </span>
              .
            </div>
          </div>
          {/* <Button block className={styles.btn} onClick={onAdvanced}>
            Try GeoFlow Advanced
          </Button> */}
        </div>
      }
    >
      <div>
        <Tooltip content="Advanced options">
          <Button
            className={classNames({
              [styles.advancedBtn]: true,
              [styles.active]: visible,
            })}
            theme="borderless"
            type="tertiary"
            size="small"
            onClick={onOpen}
            icon={<AdvancedIcon />}
          ></Button>
        </Tooltip>
      </div>
    </Popover>
  );
};

export default withField(ProteinBinderAdvancedField);
